import Component from "vue-class-component";
import Vue from "Vue";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class NotificationScroll extends Vue {
	@Prop()
	public flagScroll;

	@Prop()
	public isHeader = false;

	private sensibiliy = 0.3;
	private scrollable;
	private trackVertical;
	private thumbVertical;
	public showScrollbar = false;
	public activeEffect = false;
	public timeEffectActive = 300;
	private timer;
	private positionScrollVertical = 0;

	public mounted(): void {
		this.scrollable = <HTMLDivElement> this.$refs.scrollableHeader;
		this.trackVertical = <HTMLDivElement> this.$refs.verticaltrackHeader;
		this.thumbVertical = <HTMLDivElement> this.$refs.verticalthumbHeader;
		this.thumbVertical.style.top = 0 + "px";

		this.listenScrollbar();
	}

	@Watch("flagScroll")
	public setSizeScrollbar(): void {
		setTimeout(() => {
			this.$forceUpdate();
			this.scrollable = <HTMLDivElement> this.$refs.scrollableHeader;

			if (this.scrollable.offsetHeight != null && this.scrollable.scrollHeight != null && this.scrollable.offsetHeight === 0 && this.scrollable.scrollHeight === 0) {
				return;
			}

			const viewableRatioHeight = this.scrollable.offsetHeight / this.scrollable.scrollHeight;
			this.thumbVertical.style.height = (viewableRatioHeight >= 1) ? "100%" : this.scrollable.offsetHeight * viewableRatioHeight + "px";
			this.showScrollbar = viewableRatioHeight < 1;

			this.thumbVertical.style.top = 0 + "px";
			this.scrollable.scrollTop = 0;
		}, 1);
	}

	private listenScrollbar(): void {
		if (this.scrollable.id == "") {
			this.scrollable.addEventListener("wheel", (event) => {
				event.preventDefault();

				this.activeEffect = true;
				clearInterval(this.timer);
				this.timer = setTimeout(() => this.activeEffect = false, this.timeEffectActive);

				this.positionScrollVertical = this.getPositionScrollbarVertical(this.scrollable, event, this.positionScrollVertical);
				this.scrollable.scrollTo({ top: this.positionScrollVertical, behavior: "smooth" });
				this.thumbVertical.style.top = this.positionScrollVertical * 100 / this.scrollable.scrollHeight + "%";
			});
		}
	}

	private getPositionScrollbarVertical(el, event, scrollTop): number {
		let positionScroll = scrollTop;
		positionScroll += (event.deltaY * this.sensibiliy);

		if (positionScroll < 0) {
			positionScroll = 0;
		}
		if (positionScroll > el.scrollHeight - el.offsetHeight) {
			positionScroll = el.scrollHeight - el.offsetHeight;
		}

		return positionScroll;
	}

	public mouseOver(): void {
		this.$emit("listenMouse", true);
	}

	public mouseLeave(): void {
		this.$emit("listenMouse", false);
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/notification/notification-scroll/notification-scroll.ts